// extracted by mini-css-extract-plugin
export default {"select-container":"CustomSelect_select-container__eD7XC","select":"CustomSelect_select__FeP4b","indicator":"CustomSelect_indicator__90dgV"};